import axios from "axios";

const url = process.env.REACT_APP__BASE_URL;

/**
 * API methods available to NIID verifier accounts.
 * These calls intentionally live apart from the fixed-agent and distributor
 * clients so the verifier workflow remains self-contained.
 */
const VerifierApi = {
  fetchManualOrders: ({ token }) =>
    axios({
      url: `${url}/app/admin/manual/fetch-manual-orders`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }),

  setNiidExpiryDate: ({ token, uniqueId, niidExpiryDate }) =>
    axios({
      url: `${url}/app/admin/manual/set-niid-expiry-date`,
      method: "POST",
      data: {
        unique_id: uniqueId,
        niid_expiry_date: niidExpiryDate,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }),

  sendNiidReport: ({ token }) =>
    axios({
      url: `${url}/app/admin/manual/send-niid-report`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
};

export default VerifierApi;
